import { useMsId } from '../store/appStore';
import { PaymentCycle } from '@common/utils/premium';

const SG_TEMPLATE_ID = '69be06e3-3fe3-4ab3-97e4-bec926804865';

export enum EndFlowType {
  EDITOR = 'EDITOR',
  DOMAIN = 'DOMAIN',
  DASHBOARD = 'DASHBOARD',
  PREMIUM = 'PREMIUM',
}

interface EndFlowRedirectOptions {
  domainName?: string;
  paymentCycle?: PaymentCycle;
}

export const useEndFlowRedirect = (type: EndFlowType, options: EndFlowRedirectOptions = {}) => {
  const msId = useMsId();

  const { domainName } = options;

  switch (type) {
    case EndFlowType.EDITOR:
      return `https://manage.wix.com/edit-template/from-intro-siteless?originTemplateId=${SG_TEMPLATE_ID}&metaSiteId=${msId}&editor=sg&referralInfo=business-launcher`;

    case EndFlowType.DOMAIN:
      if (!domainName) {
        throw new Error('Domain name is required for DOMAIN redirect type');
      }
      return `https://manage.wix.com/dashboard/${msId}/add-domain?domainName=${encodeURIComponent(domainName)}`;

    case EndFlowType.DASHBOARD:
      return `https://manage.wix.com/dashboard/${msId}`;

    case EndFlowType.PREMIUM:
      const url = new URL('https://premium.wix.com/wix/api/premiumStart');

      url.searchParams.set('siteGuid', msId);
      url.searchParams.set('referralAdditionalInfo', 'add-domain-purchase-intent-dropshipping');
      url.searchParams.set('petri_ovr', 'specs.premium.RemoveLightPlanForDropShipping:true');

      if (domainName) {
        url.searchParams.set('domainName', domainName);
        url.searchParams.set('showDomain', 'true');
        url.searchParams.set(
          'successUrl',
          `https://manage.wix.com/get-domain?domainName=${domainName}&flowType=purchase`,
        );
      }

      return url.toString();

    default:
      return `https://manage.wix.com/dashboard/${msId}`;
  }
};
